import { render, staticRenderFns } from "./LinkedInIcon.vue?vue&type=template&id=5a2e2438&"
import script from "./LinkedInIcon.vue?vue&type=script&lang=js&"
export * from "./LinkedInIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports